var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrsahIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.047,
    height: 18.318,
    viewBox: "0 0 14.047 18.318",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_159861",
    "data-name": "Path 159861",
    d: "M19.549,9.865l-.3,8.93A2.941,2.941,0,0,1,16.3,21.64H10.7A2.941,2.941,0,0,1,7.748,18.8l-.3-8.933a.738.738,0,0,1,1.475-.049l.3,8.932A1.475,1.475,0,0,0,10.7,20.167H16.3a1.475,1.475,0,0,0,1.475-1.421l.3-8.929a.738.738,0,1,1,1.475.049Zm.976-2.972a.738.738,0,0,1-.738.738H7.216a.738.738,0,0,1,0-1.475H9.5a.941.941,0,0,0,.939-.847,2.206,2.206,0,0,1,2.2-1.987h1.719a2.206,2.206,0,0,1,2.2,1.987.941.941,0,0,0,.939.847h2.287a.738.738,0,0,1,.738.738Zm-8.8-.738h3.561a2.434,2.434,0,0,1-.188-.7.738.738,0,0,0-.733-.664H12.643a.738.738,0,0,0-.733.664,2.434,2.434,0,0,1-.189.7Zm.743,11.175V11.05a.738.738,0,0,0-1.475,0v6.283a.738.738,0,1,0,1.475,0Zm3.551,0V11.05a.738.738,0,0,0-1.475,0v6.283a.738.738,0,1,0,1.475,0Z",
    transform: "translate(-6.478 -3.322)",
    fill: "#7c7c7c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrsahIcon);
export default __webpack_public_path__ + "static/media/trsahIcon.349759930ce4912b7125fbd2cb110f83.svg";
export { ForwardRef as ReactComponent };